export interface BaseSpriteSource {
  width: number;
  height: number;
  frameSequences: {
    [key: string]: number[];
  };
  framesPerFrame: number;
}

export interface SpriteInstance {
  id: string;
  width: number;
  height: number;
  sequence: string;
  before?: 'foreground';
  center?: [number, number];
  route?: {
    coordinates: [number, number, number][];
    steps: number;
    bearingSequenceMap: {
      [angle: string]: string;
    };
  };
}

interface SpriteSourceWithInstances extends BaseSpriteSource {
  instances: SpriteInstance[];
}

export interface NXWConfig {
  debug: boolean;
  doceboHostname: string;
  branchGroups: { [branchGroup: string]: number[] };
  animationFps?: number;
  map: {
    center: [number, number];
    initialBoundaries: [[number, number], [number, number]];
    zoomedBoundaries: [[number, number], [number, number]];
    cameraLevels: CameraLevelSettings[];
    tileBackgroundUrl: string;
    tileForegroundUrl: string;
    tileSize: number;
    mapWidth: number;
    mapHeight: number;
  };
  buildings: Building[];
  spritesheets: {
    essential: boolean;
    url: string;
    width: number;
    height: number;
    sprites: SpriteSourceWithInstances[];
  }[];
}

export interface Catalogue {
  tabTitle: string;
  mandatory: boolean;
  doceboCatalogueId: number;
  displayConditions: DisplayConditions;
}

export interface Building {
  id: string;
  hiddenFromQuickNavigation: boolean;
  didYouKnow: string;
  markerIcon: string;
  markerPosition: [number, number];
  buildingBounds: [[number, number], [number, number]];
  catalogues: Catalogue[];
}

export interface CameraLevelSettings {
  zoom: number;
}

export enum CameraLevel {
  MINIMUM = 0,
  NORMAL = 1,
  MAXIMUM = 2,
}

export type DisplayConditionKeys = 'additionalField' | 'branchGroup';

export type DisplayConditionOperators = '===' | '!==';

export type DisplayCondition = [
  DisplayConditionKeys,
  DisplayConditionOperators,
  string
];

export type DisplayConditions = DisplayCondition[];
